export const OUTCOMES = {
    CORRECT: 'C',
    INCORRECT: 'NC',
};

export const STATUS = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
};

export const PERIOD = {
    BOY: 'BOY',
    MOY: 'MOY',
    EOY: 'EOY',
    SUMMER: 'SUMMER',
    PM: 'PM',
};

export const ALL_PERIODS = [PERIOD.BOY, PERIOD.MOY, PERIOD.EOY, PERIOD.SUMMER, PERIOD.PM];

export const PERIOD_TITLE = {
    [PERIOD.BOY]: 'Beginning of Year Benchmark',
    [PERIOD.MOY]: 'Middle of Year Benchmark',
    [PERIOD.EOY]: 'End of Year Benchmark',
    [PERIOD.SUMMER]: 'Summer Benchmark',
    [PERIOD.PM]: 'Progress Monitoring',
};

export const GRADE = {
    PK: 'PK',
    KG: 'KG',
    ONE: '01',
    TWO: '02',
    THREE: '03',
    FOUR: '04',
    FIVE: '05',
};
